/** Pure helpers for Find a member. */

/** Results start at two characters, or at one digit (account and check numbers). */
export function searchReady(q: string): boolean {
  const t = q.trim()
  return t.length >= 2 || /\d/.test(t)
}

/** Split a name around the first case-insensitive match of the query. */
export function highlight(name: string, q: string): { pre: string; hit: string; post: string } {
  const t = q.trim()
  const at = t ? name.toLowerCase().indexOf(t.toLowerCase()) : -1
  if (at < 0) return { pre: name, hit: '', post: '' }
  return { pre: name.slice(0, at), hit: name.slice(at, at + t.length), post: name.slice(at + t.length) }
}

/** Accepts a value only if it is not older than the newest one already accepted. */
export function latestOnly<T>(): (seq: number, value: T) => T | undefined {
  let newest = 0
  return (seq, value) => {
    if (seq < newest) return undefined
    newest = seq
    return value
  }
}

/** Move the highlighted row by one, stopping at either end. */
export function moveSelection(i: number, delta: 1 | -1, n: number): number {
  if (n <= 0) return 0
  return Math.min(n - 1, Math.max(0, i + delta))
}

/** True only when the rows on screen answer exactly what the field and chips say now. */
export function resultsAreCurrent(a: {
  raw: string
  q: string
  title: string
  status: string
  data?: { q: string; publication: string; status: string }
}): boolean {
  return !!a.data && a.raw.trim() === a.q && a.data.q === a.q && a.data.publication === a.title && a.data.status === a.status
}
